import { Injectable } from '@angular/core';
import { jsPDF } from 'jspdf';
import * as html2PDF from 'jspdf-html2canvas';
import * as htmlToPdfmake from 'html-to-pdfmake';
import * as pdfMake from 'pdfmake/build/pdfmake';

import { ProjectManagerService } from './project-manager.service';
import { AuthService } from './auth.service';
import { SetMaterialsService } from './set-materials.service';
import { DataForDisplayingMenuItemsService } from './data-for-displaying-menu-items.service';
import { RailingGenerationService } from './railing/services/railing-generation.service';
import { RendererService } from './renderer.service';
import { LoadingSpinnerService } from './loading-spinner.service';
import { InfillsService } from './railing/infills/infills.service';
import { RailingLightService } from './railing/light/railing-light.service';
import { GetQuoteInfoService } from '../shared/modals/modal-get-quote/services/get-quote-info.service';

@Injectable()
export class PdfService {

  constructor(
    private projectMngr: ProjectManagerService,
    private auth: AuthService,
    private setMaterialsService: SetMaterialsService,
    private dataMenuItems: DataForDisplayingMenuItemsService,
    private railingGeneration: RailingGenerationService,
    private infillsService: InfillsService,
    private rendererSrvc: RendererService,
    private loadingSpinnerService: LoadingSpinnerService,
    private railingLightSrvc: RailingLightService,
    private getQuoteInfoService: GetQuoteInfoService,
  ) {
  }

  defaultColors: Object = {
    'DesignRail' : {
      'Top Rail': 'black',
      'Bottom Rail': 'black',
      'Post': 'black',
      'Picket' : 'black'
    },
    'Wood' : {
      'Top Rail': 'Cedar',
      'Bottom Rail': 'Cedar',
      'Post': 'Cedar',
      'Picket' : 'black'
    },
    'Composite' : {
      'Top Rail': 'black',
      'Bottom Rail': 'black',
      'Post': 'black',
      'Picket' : 'black'
    },
    'Steel flat bar' : {
      'Top Rail': 'green',
      'Bottom Rail': 'green',
      'Post': 'green',
      'Picket' : 'black'
    },
    'Steel round tubular' : {
      'Top Rail': 'black',
      'Bottom Rail': 'black',
      'Post': 'black',
      'Picket' : 'black'
    },
    'DockRail' : {
      'Top Rail': 'black',
      'Post': 'black'
    },
    'Modern' : {
      'Top Rail': 'black',
      'Post': 'black',
      'Picket' : 'black'
    }
  }

  printProject(): void {
    let pdf = new jsPDF('p', 'mm', 'a4');

    let project = this.projectMngr.getCurrentProject();
    let user = this.auth.getUser();
    let currentChoices = this.dataMenuItems.getCurrentParams();
    let screenshot = this.rendererSrvc.getScreenShot();
    let legalReasonInfill = this.getQuoteInfoService.updateInfillValue(currentChoices.infill, currentChoices.railingType);
    if (currentChoices.infill.includes('laser')) {
      legalReasonInfill = legalReasonInfill + ' ' + '®';
    }
    if (currentChoices.infill.includes('Mesh')) {
      legalReasonInfill = legalReasonInfill + ' ' + 'TM';
    }
    // console.log(pdf.internal.pageSize.getWidth());
    // console.log(pdf.internal.pageSize.getHeight());

    let logoImageBase64Data;
    this.loadingSpinnerService.spinnerLoadingListAdd('printProject');
    this.convertImgPathToBase64DataURL('../assets/images/feeney_logo.png', 74, 16).then(
      img => {
        this.loadingSpinnerService.spinnerLoadingListRemove('printProject');
        logoImageBase64Data = img;
        // add logo
        pdf.addImage(logoImageBase64Data, 'PNG', 10, 10, 74, 16);

        // add 3d screenshot
        //TODO: remove hardcoded values and 3d screenshot
        pdf.addImage(screenshot, 'PNG', 20, 62, 170, 120);

        pdf.setFontSize(20);
        pdf.text("Feeney VisualBuilder", 120, 10);

        pdf.setFontSize(16);
        // pdf.setFontStyle('italic');
        pdf.text("Design it, build it, love it!", 126, 20);

        // pdf.setFontStyle('normal');
        pdf.setFontSize(10);
        // pdf.setFontType('bold');
        pdf.text("Date", 10, 40);
        pdf.text("Project name", 10, 45);
        pdf.text("Project type", 10, 50);

        // pdf.setFontType('normal');
        pdf.text(this.getDate(), 45, 40);
        pdf.text(project.projectName, 45, 45);
        pdf.text(project.projectType, 45, 50);


        pdf.setFontSize(10);
        // pdf.setFontType('bold');
        pdf.text("First/Last Name", 120, 40);
        pdf.text("Phone", 120, 45);
        pdf.text("Email", 120, 50);

        // pdf.setFontType('normal');
        pdf.text(`${user.firstName} ${user.lastName}`, 157, 40);
        pdf.text(user.phone ? user.phone : '', 157, 45);
        pdf.text(user.email ? user.email : '', 157, 50);


        pdf.setDrawColor('#adadad');
        pdf.rect(10, 60, 190, 212);

        pdf.setFillColor('#00b8cd');
        pdf.rect(10, 275, 190, 14, 'F');
        pdf.setTextColor(0, 0, 0);
        pdf.text("1-800-888-2418", 60, 283);
        pdf.setTextColor(250, 250, 250);
        pdf.text("•", 98, 283);
        pdf.setTextColor(0, 0, 0);
        pdf.text("www.feeneyinc.com", 104, 283);

        // pdf.setFontType('bold');
        pdf.text("DETAILS", 90, 195);

        pdf.setFontSize(10);
        // pdf.setFontType('bold');
        pdf.text("Deck material", 20, 200);
        pdf.text("Railing type", 20, 205);
        pdf.text("Post mounting", 20, 210);
        pdf.text("Corner posts", 20, 215);
        pdf.text("Railing height", 20, 220);
        pdf.text("Top rail", 20, 225);
        pdf.text("Infill", 20, 230);
        pdf.text("Stair handrail", 20, 235);
        pdf.text("Post caps", 20, 240);

        // pdf.setFontType('normal');
        if(this.setMaterialsService.getCurrentFloorTexture() === 'default'){
          pdf.text('cedar', 70, 200);
        }else{
          pdf.text(this.setMaterialsService.getCurrentFloorTexture(), 70, 200);
        }
        pdf.text(currentChoices.railingType, 70, 205);
        pdf.text(currentChoices.postMounting, 70, 210);
        pdf.text(currentChoices.cornerPosts, 70, 215);
        // http://146.185.164.175:8080/browse/FR-1001
        const railingHeight = currentChoices.railingHeight === '38' ? '38' : currentChoices.railingHeight;
        pdf.text(railingHeight, 70, 220);
        pdf.text(currentChoices.topRail, 70, 225);
        pdf.text(legalReasonInfill, 70, 230);
        pdf.text("", 70, 235);
        pdf.text(this.railingGeneration.getIsShowPostCaps() ? 'Yes' : 'No', 70, 240);


        pdf.setFontSize(10);
        // pdf.setFontType('bold');
        pdf.text("Lighting", 140, 200);
        pdf.text("Top rail", 145, 205);
        pdf.text("Bottom rail", 145, 210);
        pdf.text("Post accent", 145, 215);
        pdf.text("Railing colors", 140, 220);
        pdf.text("Post", 145, 225);
        pdf.text("Top rail", 145, 230);
        pdf.text("Bottom rail", 145, 235);
        pdf.text("Picket", 145, 240);

        // pdf.setFontType('normal');
        pdf.text(this.railingLightSrvc.topRailLight ? 'Yes' : 'No', 175, 205);
        pdf.text(this.railingLightSrvc.bottomRailLight ? 'Yes' : 'No', 175, 210);
        pdf.text(this.railingLightSrvc.postLight ? 'Yes' : 'No', 175, 215);

        // hardcode
        // change later
        let railingParams = this.dataMenuItems.getCurrentParams();
        let colors = this.dataMenuItems.getRailingCurrentColor(railingParams.railingType)
        if (colors) {
          for(let color in colors){
            switch (color) {
              case "Post":
              if(colors[color].selected.name){
                pdf.text(colors[color].selected.name, 175, 225);
              }
              else{
                pdf.text(this.getDefaultColor(railingParams.railingType, "Post"), 175, 225);
              }
                break;
              case "Top Rail":
              if(colors[color].selected.name){
                pdf.text(colors[color].selected.name, 175, 230);
              }
              else{
                pdf.text(this.getDefaultColor(railingParams.railingType, "Top Rail"), 175, 230);
              }
                break;
              case "Bottom Rail":
              if(colors[color].selected.name){
                pdf.text(colors[color].selected.name, 175, 235);
              }
              else{
                pdf.text(this.getDefaultColor(railingParams.railingType, "Bottom Rail"), 175, 235);
              }
                break;
              case "Picket":
              if(colors[color].selected.name){
                pdf.text(colors[color].selected.name, 175, 240);
              }
              else{
                pdf.text(this.getDefaultColor(railingParams.railingType, "Picket"), 175, 240);
              }
                break;
            }
          }
        }else{
          pdf.text(this.getDefaultColor(railingParams.railingType, "Post"), 175, 225);
          pdf.text(this.getDefaultColor(railingParams.railingType, "Top Rail"), 175, 230);
          pdf.text(this.getDefaultColor(railingParams.railingType, "Bottom Rail"), 175, 235);
          pdf.text(this.getDefaultColor(railingParams.railingType, "Picket"), 175, 240);
        }

        pdf.setFontSize(12);
        // pdf.setFontType('bold');
        // pdf.setFontStyle('italic');
        pdf.text("Product and color disclaimer", 80, 255);

        pdf.setFontSize(7);
        // pdf.setFontType('normal');
        // pdf.setFontStyle('italic');
        pdf.text("Products and product colors may not be exactly as shown due to variance in monitor and printer calibrations. Product and color availability can vary by region. As result,", 10, 260);
        pdf.text("some of the products and colors you see may not be available in your area. We strongly recommend viewing the actual product before making final selection.", 10, 265);

        pdf.autoPrint();
        // window.location = pdf.output('bloburl');
        window.open(`${pdf.output('bloburi')}`, '_blank');
      }
    );
  }

  async createPdfProject(name: string) {
    const page = document.getElementById('pdf');
    const pdf = await html2PDF(page, {
      jsPDF: {
        format: 'a4',
      },
      // imageType: 'image/jpeg',
      output: 'project.pdf'
    });

    return pdf.output('blob');
  }

  private getDate(): string {
    let today = new Date();
    let dd: any = today.getDate();
    let mm: any = today.getMonth() + 1; //January is 0!

    let yyyy = today.getFullYear();
    if (dd < 10) {
      dd = '0' + dd;
    }
    if (mm < 10) {
      mm = '0' + mm;
    }
    return dd + '/' + mm + '/' + yyyy;
  }


  convertImgPathToBase64DataURL(url, w, h) {
    return new Promise(function (ok) {
      let img = <any>new Image();
      // img.style = 'width:' + w + 'pt; height:' + h + 'pt;';
      img.crossOrigin = 'Anonymous';
      img.onload = function () {
        let canvas = <any>document.createElement('CANVAS');
        let ctx = canvas.getContext('2d');
        canvas.height = this.height;
        canvas.width = this.width;
        ctx.drawImage(this, 0, 0);
        ok(canvas.toDataURL('image/png'));
      };
      img.src = url;
    });
  }

  getDefaultColor (railingType: string, item: string) : string {
      return this.defaultColors[railingType][item]
  }

}



// WEBPACK FOOTER //
// ./src/app/services/pdf.service.ts